export const buildQueryString = (args: Record<string, any>) =>
  Object.entries(args ?? {})
    .map(([key, value]) => `${key}=${value}`)
    .filter(Boolean)
    .join('&');
